import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ARROW_EDITOR_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { Location } from "@angular/common";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { finalize } from "rxjs/operators";

@Component({
    selector: ARROW_EDITOR_SELECTOR,
    templateUrl: "./arroweditor.component.html"
})
export class ArrowEditorComponent extends BaseComponent implements OnInit {

    @Output() public arrowSave = new EventEmitter<boolean>();
    @Output() public closeSection: EventEmitter<{}> = new EventEmitter();
    @Input() public editedMarkerUUID: string;

    public radioValue: string;

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        protected alertUtils: AlertUtils,
        private photosphereManager: PhotosphereManager) {
        super(appComponent, router, alertUtils, location);
    }

    ngOnInit(): void {
        this.appComponent.startLoading();
        this.photosphereManager.getMarker(this.editedMarkerUUID)
            .pipe(
                finalize(() => this.appComponent.stopLoading())
            )
            .subscribe((marker) => {
                this.radioValue = marker.enabled ? "true" : "false";
            });
    }

    public onArrowSave() {
        if(this.radioValue === "true") {
            this.arrowSave.emit(true);
        } else {
            this.arrowSave.emit(false);
        }
    }

    public onClose() {
        this.closeSection.emit();
    }
}